module.exports = __webpack_public_path__ + "img/teamwork.1b116841.svg";